// --------------------------------------------------------------
// Created On: 2024-04-11
// Author: Hannah Vaughan
//
// Last Modified: 2025-01-07
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

export const MANUAL_URL = "https://cornellpump.westus.cloudapp.azure.com";
export const PUMP_CURVES_URL = "https://ecatalog.cornellpump.com";
export const EXPLODED_DRAWING_URL = "https://cornellpump.westus.cloudapp.azure.com";
export const VIDEOS_URL = "https://www.youtube.com";
export const SHOP_URL = "https://shopcornellpump.com";
export const RPM_URL = "https://rpm-squared.com/login";
export const RPM_MANUAL_URL = "https://rpm-squared.com/manuals/Manual%20";
export const RPM_SCAN_ASSET_URL = "https://rpm-squared.com/scan-asset/";
